module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-insurance@2-e56d71e56e198cc9c7b51a980ad05d69.jpg";